import { OverAllReport } from './OverAllReport'
import { withOverAllReport } from './withOverAllReport'

const ConnectedOverAllReport = withOverAllReport(OverAllReport)

export { ConnectedOverAllReport as OverAllReport }
